import { ComponentChildren } from "preact";
import { useFadeTransition } from "../../hooks/useFadeTransition";

type FadeProps = {
  visible: boolean;
  children: ComponentChildren;
  duration?: number;
  delay?: number;
  onExited?: () => void;
  className?: string;
  unmountOnExit?: boolean;
};

/**
 * A component that fades its children in and out, with proper DOM mounting/unmounting
 */
export function Fade({
  visible,
  children,
  duration = 500,
  delay = 0,
  onExited,
  className = "",
  unmountOnExit = true
}: FadeProps) {
  const { isMounted, fadeProps } = useFadeTransition({
    visible,
    duration,
    delay,
    onExited
  });

  // If not mounted and we want to unmount on exit, don't render anything
  if (!isMounted && unmountOnExit) {
    return null;
  }

  return (
    <div className={className} {...fadeProps}>
      {children}
    </div>
  );
}